module.exports = __webpack_public_path__ + "static/media/header-checkerboard.7aebf71d.svg";